import fetch from "auth/FetchInterceptor";

const authUserRoleService = {};

authUserRoleService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/auth-user-role",
		method: "get",
		params,
	});
};

authUserRoleService.post = function (data) {
	return fetch({
		url: "/v1/rest/auth-user-role",
		method: "post",
		data: data,
	});
};

authUserRoleService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/auth-user-role/${id}`,
		method: "put",
		data: data,
	});
};

authUserRoleService.getById = function (id) {
	return fetch({
		url: `/v1/rest/auth-user-role/${id}`,
		method: "get",
	});
};

authUserRoleService.getUserPermissionGroup = function () {
	return fetch({
		url: "/v1/rest/user-permission-company",
		method: "get",
	});
};

export default authUserRoleService;
